import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const reclaimMerchantRowSchema = z.object({
  teamId: z.string(),
  teamName: z.string(),
  accountId: z.string(),
  totalDisputes: z.number().int(),
  openChargebacks: z.number().int(),
  evidenceGenerated: z.number().int(),
  won: z.number().int(),
  lost: z.number().int(),
  automateEvidenceEnabled: z.boolean(),
  billingEnabled: z.boolean(),
  evidenceGeneratedAmount: z.number(),
});

export interface ReclaimMerchantRow
  extends z.infer<typeof reclaimMerchantRowSchema> {}

export const getReclaimMerchants = unaryRpc({
  name: "getReclaimMerchants" as const,
  input: z.null(),
  output: z.object({ merchants: z.array(reclaimMerchantRowSchema) }),
});
